<template>
  <section class="relative pb-0">
    <tilted-background background-color="white" class="pb-12 m:pb-16" />

    <spaces-explainer-mobile
      :copy="$t('slider')"
      :space-b2b="spaceB2b"
      class="s:hidden pb-12 m:pb-16"
      :login-path="loginPath"
      :signup-path="signupPath"
    />
    <spaces-explainer-desktop
      :copy="$t('slider')"
      :space-b2b="spaceB2b"
      class="hidden s:block pb-12 m:pb-16"
      :login-path="loginPath"
      :signup-path="signupPath"
    />

    <div
      class="relative bg-summer-yellow h-12 -bottom-px l:h-16 w-full"
      style="clip-path: polygon(100% 0, 0 100%, 100% 100%)"
    />
  </section>
</template>

<script>
import TiltedBackground from "@/component-library/tilted-background"

import SpacesExplainerMobile from "@/pages/spaces/join-page/components/spaces-explainer/spaces-explainer-mobile"
import SpacesExplainerDesktop from "@/pages/spaces/join-page/components/spaces-explainer/spaces-explainer-desktop"

export default {
  name: "SpacesExplainer",
  components: {
    TiltedBackground,
    SpacesExplainerMobile,
    SpacesExplainerDesktop
  },
  props: {
    spaceB2b: {
      type: Boolean,
      required: true
    },
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        slider: [
          {
            title: "What can I do with Blinkist Spaces?",
            subtitle: "You’ll get access to your friend’s Spaces and can create* your own",
            subtitleB2b: "You get access to your colleagues’ Spaces and can create your own",
            caption:
              "*Creating a Space is only available to Premium Blinkist members, but joining a Space and enjoying what’s been shared is free to anyone invited.",
            captionB2b: null // intentional to skip displaying it for B2B
          },
          {
            title: "Listen to what’s been shared",
            subtitle: "In each space you can listen to or read what’s been shared by your friends",
            subtitleB2b: "Inside each space you can listen/read to what has been shared by your colleagues"
          },
          {
            title: "Share your favorite titles",
            subtitle: "Add* your favorite titles to a Space and learn together",
            subtitleB2b: "Add your favorite titles to a Space and learn together",
            caption:
              "*Adding a title to a Space is only available for Premium Blinkist users, but joining a space and listening to what’s been shared is free for anyone who is invited.",
            captionB2b: null // intentional to skip displaying it for B2B
          }
        ]
      },
      de: {
        slider: [
          {
            title: "Was kann ich in Blinkist Spaces machen?",
            subtitle: "Du erhältst Zugang zu den Spaces deiner Freunde und kannst eigene Spaces erstellen*",
            subtitleB2b: "Du erhältst Zugang zu den Spaces deiner Kollegen und kannst eigene Spaces erstellen",
            caption:
              "*Nur Blinkist Premium Nutzer können Spaces erstellen. Basic Nutzer können Spaces beitreten und kostenlos alle Titel anhören, die mit ihnen geteilt wurden.",
            captionB2b: null // intentional to skip displaying it for B2B
          },
          {
            title: "Höre dir Empfehlungen an",
            subtitle: "Du kannst in jedem Space kostenlos alle Empfehlungen deiner Freunde anhören oder lesen",
            subtitleB2b: "Du kannst in jedem Space kostenlos alle Empfehlungen deiner Kollegen anhören oder lesen"
          },
          {
            title: "Teile deine Lieblingstitel",
            subtitle: "Füge deine Lieblingstitel zu Spaces hinzu* und teile sie mit anderen",
            subtitleB2b: "Füge deine Lieblingstitel zu Spaces hinzu und teile sie mit anderen",
            caption:
              "*Nur Blinkist Premium Nutzer können Titel zu Spaces hinzufügen. Basic Nutzer können Spaces beitreten und kostenlos alle Titel anhören, die mit ihnen geteilt wurden.",
            captionB2b: null // intentional to skip displaying it for B2B
          }
        ]
      }
    }
  }
}
</script>

<style>
.snap-x {
  scroll-snap-type: x mandatory;
}

.snap-center {
  scroll-snap-align: center;
}

.image {
  flex-shrink: 0;
  width: 233px;
  height: 457px;
}
</style>
